import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const CustomMovementsSectionHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="nk-block-between d-flex flex-column flex-md-row">
      <div className="nk-block-head-content">
        <h4 className="nk-block-title">{t('CustomMovements')}</h4>
        <div className="nk-block-des">
          <p>{t('CustomMovementsTabDescription')}</p>
        </div>
      </div>
    </div>
  );
};

export default CustomMovementsSectionHeader;
